var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00342 6.49281C7.83167 6.49281 9.31376 5.03936 9.31376 3.24644C9.31376 1.45351 7.83167 6.10352e-05 6.00342 6.10352e-05C4.17517 6.10352e-05 2.69307 1.45351 2.69307 3.24644C2.69307 5.03936 4.17517 6.49281 6.00342 6.49281Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00342 8.116C2.68971 8.116 0.00341797 10.7504 0.00341797 14.0001H12.0034C12.0034 10.7504 9.31713 8.116 6.00342 8.116Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconWhite);
export default __webpack_public_path__ + "static/media/user-icon-white.f7c44b72.svg";
export { ForwardRef as ReactComponent };